import React from "react";
import SearchInputs from "./src/searchInputs";
import SearchResults from "./src/searchResults";
import RatingAnalytics from "./src/analytics/ratingAnalytics";
import { User, AppContext } from "../../context/appContext";
import checkPermissionAdmin from "../../functions/checkPermissionAdmin";

const RatingOverviewContainer = (): React.JSX.Element => {
  const {
    user,
  }: {
    user: User;
  } = React.useContext(AppContext);

  return (
    <React.Fragment>
      <SearchInputs />
      {checkPermissionAdmin(user) && <RatingAnalytics />}
      <SearchResults />
    </React.Fragment>
  );
};

export default RatingOverviewContainer;
